<template>
  <div>
    <div class="audio-player" :class="{'audio-player-scrubbing': isScrubbing, 'audio-player-playing': isPlaying}">
        <audio ref="audio" :src="src" @canplaythrough="updateTime" @timeupdate="updateTime"></audio>
        <p>{{ formatTime(currentTime) }}</p>
        <p @click="togglePlayback" class="playbutton" v-html="isPlaying ? 'PAUSE' : 'PLAY'" />
        <p>{{ formatTime(duration) }}</p>
        <div
          class="audio-bar"
          :style="{'--percentage': percentage}"
          @click="seekTime"
          @mousedown="startScrubbing"
          @mousemove="scrubTime"
          @mouseup="stopScrubbing"
          @mouseout="stopScrubbing"
        />
    </div>
    <div class="caption" v-html="$root.md(caption)"/>
  </div>
</template>

<script>

export default {
  props: {
    src: String,
    caption: String
  },
  data () {
    return {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      percentage: 0,
      isScrubbing: false
    }
  },
  mounted () {
    this.playListener = (e) => {
      if (e !== this.src) {
        const audio = this.$refs.audio
        this.isPlaying = false
        audio.pause()
      }
    }
    this.$root.$on('media-play', this.playListener)
  },
  beforeDestroy () {
    this.$root.$off('media-play', this.playListener)
  },
  methods: {
    togglePlayback () {
      const audio = this.$refs.audio
      if (this.isPlaying) {
        audio.pause()
      } else {
        audio.play()
        this.$root.$emit('media-play', this.src)
      }
      this.isPlaying = !this.isPlaying
    },
    updateTime () {
      const audio = this.$refs.audio
      this.currentTime = audio.currentTime
      this.duration = audio.duration
      this.percentage = 1 / audio.duration * audio.currentTime
    },
    formatTime (time) {
      const minutes = Math.floor(time / 60)
      const seconds = Math.floor(time % 60)
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0'
      )}`
    },
    seekTime (event) {
      const audio = this.$refs.audio
      const rect = event.target.getBoundingClientRect()
      const offsetX = event.clientX - rect.left
      const percentage = 1 / rect.width * offsetX
      audio.currentTime = percentage * audio.duration
    },
    startScrubbing () {
      this.isScrubbing = true
    },
    scrubTime (event) {
      if (this.isScrubbing) {
        this.seekTime(event)
      }
    },
    stopScrubbing () {
      this.isScrubbing = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../main';

.audio-player {
  text-transform: uppercase;
  @include headerfont;
  margin: auto;
  width: 100%;
  border: 1px solid;
  height: var(--menuwidth-hidden);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  cursor: pointer;
}
.audio-player-scrubbing {
  p {
    pointer-events: none;
  }
  .audio-bar {
    &:after {
      transition: none;
    }
  }
}
.playbutton {
  &:before {
    content: '';
    display: inline-block;
    width: 1rem;
    height: .9rem;
    padding-right: 0.5rem;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><polygon points="0,0 70,50 0,100" fill="white"/></svg>') no-repeat center center;
    background-size: contain;
  }
}
.audio-player-playing {
  .playbutton {
    &:before {
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect x="0" y="0" width="33" height="100" fill="white"/><rect x="50" y="0" width="33" height="100" fill="white"/></svg>') no-repeat center center;
    }
  }
}

audio {
    display: none;
}

.audio-bar {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0px;
    top: 0px;
    &:after {
      content: "";
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0px;
      top: 0px;
      z-index: 0;
      background: white;
      transform: scaleX(var(--percentage));
      transition: transform 0.5s;
      transform-origin: left center;
    }
}

p {
    color: white;
    margin: 0;
    z-index: 1;
    padding: var(--padding-05);
    mix-blend-mode: difference;
    flex-basis: 4em;
    text-align: center;
    white-space: nowrap;
    @include hover() {
      color: var(--link-hover-color);
    }
    &:first-of-type {
      text-align: left;
      pointer-events: none;
    }
    &:last-of-type {
      text-align: right;
      pointer-events: none;
    }
}

.caption {
    @include smallfont;
    padding-top: var(--padding-05);
}

</style>



// WEBPACK FOOTER //
// src/components/Audioplayer.vue